import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Clone from './icon-clone.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Clone {...validProps} />;
}
SvgComponent.iconName = 'clone-icon';

/**
 * @deprecated This is a legacy icon
 */
export const CloneIcon = svgIconWrapper(SvgComponent);
